module.exports = __webpack_public_path__ + "static/media/frozen9.0c5c9d43.png";